/**
 * 解析方法の表示ラベル（FR-007）。
 *
 * `BROWSER_LLM → 端末内AI` / `SERVER_LLM → サーバAI` / `RULE → ルール`。
 * 後方互換の `LLM` はサーバAI として扱う。
 */
export function formatAnalysisMethod(method?: string): string {
  switch (method) {
    case 'BROWSER_LLM':
      return '端末内AI';
    case 'SERVER_LLM':
    case 'LLM':
      return 'サーバAI';
    case 'RULE':
      return 'ルール';
    default:
      return '-';
  }
}
